const cheerio = require("cheerio")
const moment = require("moment")
// eslint-disable-next-line
const moment_de = require("moment/locale/de")

function formatDateRange(props) {
  moment.locale("de")
  var startformat = ""
  var endformat = ""
  var startdateformat = ""
  var enddateformat = ""
  var dateformat = ""
  var day = ""
  var monthYear = ""

  if (props.singledate) {
    dateformat = moment(props.singledate).format(props.format)
  } else if (props.startdate && moment(props.startdate).isValid()) {
    if (props.enddate && moment(props.enddate).isValid()) {
      if (
        moment(props.startdate).format("YYYY") ===
        moment(props.enddate).format("YYYY")
      ) {
        if (
          moment(props.startdate).format("MM") ===
          moment(props.enddate).format("MM")
        ) {
          if (
            moment(props.startdate).format("DD") ===
            moment(props.enddate).format("DD")
          ) {
            day = moment(props.startdate).format("DD.")
            monthYear = moment(props.startdate).format("MMMM YYYY")
            if (
              props.forceTimeOutput &&
              moment(props.startdate).format("H") !== "0" &&
              moment(props.enddate).format("H") !== "0"
            ) {
              monthYear += ", " + moment(props.startdate).format("HH:mm")
              monthYear += " - " + moment(props.enddate).format("HH:mm [Uhr]")
            } else {
              if (
                props.forceTimeOutput &&
                moment(props.startdate).format("H") !== "0"
              ) {
                monthYear +=
                  ", " + moment(props.startdate).format("HH:mm [Uhr]")
              }
            }
            dateformat =
              '<div class="dfb-Card-eventDay">' +
              day +
              '</div><div class="dfb-Card-eventMonth">' +
              monthYear +
              "</div>"
          } else {
            if (
              props.forceTimeOutput &&
              moment(props.startdate).format("H") !== "0" &&
              moment(props.enddate).format("H") !== "0"
            ) {
              day = moment(props.startdate).format("DD.MM.YYYY")
              day += ", " + moment(props.startdate).format("HH:mm")
              day += " - <br>" + moment(props.enddate).format("DD.MM.YYYY")
              day += ", " + moment(props.enddate).format("HH:mm [Uhr]")
              dateformat = '<div class="dfb-Card-eventDay">' + day + "</div>"
            } else {
              day = moment(props.startdate).format("DD.")
              day += " - " + moment(props.enddate).format("DD.")
              monthYear = moment(props.startdate).format("MMMM YYYY")
              dateformat =
                '<div class="dfb-Card-eventDay">' +
                day +
                '</div><div class="dfb-Card-eventMonth">' +
                monthYear +
                "</div>"
            }
          }
        } else {
          startformat = props.format.replace(" YYYY", "")
          startformat = startformat.replace("YYYY", "")
          startformat = startformat.replace(", HH:mm [Uhr]", "")
          startformat = startformat.replace("MM.", "MM. - ")
          startformat = startformat.replace("DD.", "DD.")
          startdateformat = moment(props.startdate).format(startformat)
          endformat = props.format.replace("YYYY", "")
          endformat = endformat.replace(", HH:mm [Uhr]", "")
          endformat = endformat.replace(" MM.", "MM.")
          endformat = endformat.replace("DD.", "DD.")
          enddateformat = moment(props.enddate).format(endformat)
          dateformat =
            '<div class="dfb-Card-eventDay dfb-Card-eventDay--small">' +
            startdateformat +
            enddateformat +
            "</div>"
          dateformat =
            dateformat +
            '<div class="dfb-Card-eventMonth">' +
            moment(props.enddate).format("YYYY") +
            "</div>"
        }
      } else {
        startformat = props.format
        startdateformat = moment(props.startdate).format(startformat)
        endformat = props.format
        endformat = endformat.replace("DD.", "<br>- DD.")
        enddateformat = moment(props.enddate).format(endformat)
        dateformat =
          '<div class="dfb-Card-eventDay">' +
          startdateformat +
          enddateformat +
          "</div>"
      }
    } else {
      day = moment(props.startdate).format("DD.")
      monthYear = moment(props.startdate).format("MMMM YYYY")
      if (
        props.forceTimeOutput &&
        moment(props.startdate).format("H") !== "0"
      ) {
        monthYear += ", " + moment(props.startdate).format("HH:mm [Uhr]")
      }
      dateformat =
        '<div class="dfb-Card-eventDay">' +
        day +
        '</div><div class="dfb-Card-eventMonth">' +
        monthYear +
        "</div>"
    }
  }
  if (props.withoutMarkup === true) {
    dateformat = dateformat.replace(
      '<div class="dfb-Card-eventDay dfb-Card-eventDay--small">',
      ""
    )
    dateformat = dateformat.replace('<div class="dfb-Card-eventDay">', "")
    dateformat = dateformat.replace('<div class="dfb-Card-eventMonth">', "")
    if (props.forceTimeOutput !== true) {
      dateformat = dateformat.replace(/<br>/g, " ")
    }
    dateformat = dateformat.replace(/<\/div>/g, " ")
  }

  return dateformat
}

function formatDate(date) {
  if (!date || !date.getTime || !date.getTime()) {
    return ""
  }
  return moment(date).format("DD.MM.YYYY")
}

/**
 * Returns the category icon type that can be used with a DfbSymbol.
 * When the category description contains a "dfb-icon-" the description
 * is use to create the icon type. Otherwise the title is returned directly.
 * @param categoryObject Category Object with "title" and "description"
 */
function getCategoryIconType(categoryObject) {
  if (!categoryObject) {
    return undefined
  }
  if (categoryObject.description?.startsWith("dfb-icon-")) {
    return categoryObject.description
      .substring(9)
      .replace(/\b[a-z]/g, (match) => match.toUpperCase())
  }
  return categoryObject.title
}

function categoryIconMapping(category) {
  var svgClass = null
  var useHash = null
  // Mapping wegen umbenannten Kategorien
  if (category.includes("Medizin")) {
    svgClass = "Physiologie"
    useHash = "physiologie"
  } else if (category === "Psychologie") {
    svgClass = "Leistungspsychologie"
    useHash = "leistungspsychologie"
    // Konvertierung für Alle Icons, die sich an die Regeln halten.
  } else {
    svgClass = category
      .replace(/ & /g, "-")
      .replace(/ /g, "-")
      .replace(/ö/g, "oe")
      .replace(/o\u0308/g, "oe")
      .replace(/ä/g, "ae")
      .replace(/a\u0308/g, "ae")
      .replace(/ü/g, "ue")
      .replace(/u\u0308/g, "ue")

    useHash = svgClass.replace(/-und-/g, "-").toLowerCase()
    svgClass = svgClass.replace(/-und-/g, "")
  }

  if (
    svgClass &&
    useHash &&
    process.env.CATEGORY_ICON_HASHES.split(",").indexOf(useHash) !== -1
  ) {
    return {
      svgClass: svgClass,
      useHash: useHash,
    }
  } else {
    return false
  }
}

/**
 * Will return the unique root category icon names from the pageList that can safely
 * be associated with the requested category ids.
 * When a requested category id is found in the content.categories property the root category
 * is mapped by taking...
 * - the first root category when there is only one root category
 * - the first root category if the category is the first category
 * - the root category at the same index as the category when both length are the same
 * The order of the result is the order of the requested category ids.
 * @param pageList List of page objects that have content.root_categories and optional a content.categories property.
 * @param requestedCategoryIds Array of unique category uids which might be root (number).
 */
function getUsedRootCategoryIconTypes(pageList, requestedCategoryIds) {
  const result = []
  if (
    requestedCategoryIds &&
    requestedCategoryIds.length &&
    pageList &&
    pageList.length
  ) {
    requestedCategoryIds.forEach((uid) => {
      pageList.some((page) => {
        if (!page.content || !page.content.root_categories) {
          return false
        }
        const rootCategories = page.content.root_categories
        if (
          rootCategories.some((category) => {
            if (category.uid === uid) {
              const iconType = getCategoryIconType(category)
              if (iconType && !result.includes(iconType)) {
                result.push(iconType)
              }
              return true
            }
            return false
          })
        ) {
          return true
        } else if (page.content.categories) {
          return page.content.categories.some((category, index) => {
            if (category.uid === uid) {
              let rootCategory = null
              if (rootCategories.length === 1) {
                rootCategory = rootCategories[0]
              } else if (
                rootCategories.length === page.content.categories.length
              ) {
                rootCategory = rootCategories[index]
              } else if (index === 0) {
                rootCategory = rootCategories[0]
              }
              if (rootCategory) {
                const iconType = getCategoryIconType(rootCategory)
                if (iconType && !result.includes(iconType)) {
                  result.push(iconType)
                }
                return true
              }
            }
            return false
          })
        }
        return false
      })
    })
  }
  return result
}

function concatStrings() {
  const args = Array.prototype.slice.call(arguments)
  return args.filter((n) => n).join(" ")
}

function defineBgColor(color, fallback) {
  return color || fallback ? `u-BgColor-${color || fallback}` : ""
}

function isTransparentHeaderSupported(firstContentElement) {
  const transparentHeaderModulesTypes = ["m_hero_slider", "m_hero", "m_match_hero", "m_team_slider", "m_person_hero"]

  if (
    firstContentElement &&
    firstContentElement.component &&
    transparentHeaderModulesTypes.includes(firstContentElement.component)
  ) {
    return true
  } else if (
    firstContentElement &&
    firstContentElement.component &&
    firstContentElement.component === "html" &&
    firstContentElement.text.indexOf("m-Hero") !== -1
  ) {
    return true
  }
  return false
}

function getTitleImage(item, fallbackImgSrc) {
  if (item.content?.titleimage) {
    return item.content.titleimage
  }
  if (
    item.content &&
    item.content.body &&
    item.content.body[0] &&
    item.content.body[0].image &&
    item.content.body[0].image.src
  ) {
    return item.content.body[0].image
  }
  if (item.metadata && item.metadata.ogimage && item.metadata.ogimage.src) {
    return item.metadata.ogimage
  }
  if (fallbackImgSrc !== undefined) {
    if (fallbackImgSrc) {
      return {
        src: fallbackImgSrc,
      }
    }
    // a fallback image is explicitly not wanted
    return null
  }
  return {
    src: process.env.FALLBACK_TEASER_IMAGE,
  }
}

function retrieveItemImageFromHero(collection, fallbackImgSrc) {
  return collection
    .filter(function (el) {
      return el !== null
    })
    .map((item) => {
      const { content, ...otherProps } = item
      // clone content item since we will modify it
      const result = {
        content: { ...content },
        ...otherProps,
      }
      const titleImage = getTitleImage(item, fallbackImgSrc)
      if (titleImage) {
        result.content.titleimage = titleImage
      } else {
        result.hide_image = true
      }
      return result
    })
}

function replaceUTF8Codes(text) {
  const findArray = ["&#x0022;"]
  const replaceArray = ['"']
  if (text) {
    let i,
      regex = [],
      map = {}
    for (i = 0; i < findArray.length; i++) {
      regex.push(findArray[i].replace(/([-[\]{}()*+?.\\^$|#,])/g, "\\$1"))
      map[findArray[i]] = replaceArray[i]
    }
    regex = regex.join("|")
    text = text.replace(new RegExp(regex, "g"), function (matched) {
      return map[matched]
    })
  }
  return text
}

function truncateTextByWords(text, words = 20) {
  return text.split(" ").slice(0, words).join(" ")
}

function searchResultHeaderData(result) {
  const relevantSourceHandles = {
    "akademie-studien": function () {
      return "Wissen"
    },
    "akademie-news": function () {
      return "News _ " + result.pub_date
    },
    "akademie-kolumnen": function () {
      return "Kolumne _ " + result.pub_date
    },
    "akademie-inhalte": function () {
      return null
    },
  }

  if (typeof relevantSourceHandles[result.source_handle] === "function") {
    return relevantSourceHandles[result.source_handle]()
  } else {
    return null
  }
}

function setSearchResultMarker(text, searchString) {
  let reg = new RegExp(`\\b(${searchString})\\b`, "gi")
  return text.replace(reg, '<mark class="c-SearchResult-mark">$1</mark>')
}

function replaceTypo3Links(html) {
  const regex1 = /(<LINK )(\S*)(.*)(>)(.*)(<\/link>)/gm
  let newHtml = html.replace(
    regex1,
    function (match, p1, p2, p3, p4, p5, offset, string) {
      return `<a href="${p2}" target="_blank" class="">${p5}</a>`
    }
  )
  return newHtml
}

function externalizeAnchors(html) {
  let newHtml = html
  let htmlDOM = cheerio.load(html)
  if (htmlDOM("a").get().length > 0) {
    htmlDOM("a").each(function (i, anchor) {
      let href = htmlDOM(this).attr("href")
      if (
        href.indexOf("//") === 0 ||
        href.indexOf("http://") === 0 ||
        href.indexOf("https://") === 0
      ) {
        htmlDOM(this).attr("target", "_blank")
      }
    })
    newHtml = htmlDOM.html()
  }
  return newHtml
}

function wrapListItemContents(html, tagName) {
  let newHtml = html
  let wrapWith = tagName ? tagName : "p"
  let htmlDOM = cheerio.load(html)
  if (htmlDOM("li").get().length > 0) {
    htmlDOM("li").each(function (i, li) {
      let listitem = htmlDOM(this)
      // wrap only when the li has more than one child
      if (listitem.contents().length > 1) {
        listitem.html(
          "<" + wrapWith + ">" + listitem.html() + "</" + wrapWith + ">"
        )
      }
    })
    newHtml = htmlDOM.html()
  }
  return newHtml
}

function sanitizeNewsText(text) {
  return text.replace("###more###", "")
}

// Wrap table contents in a scrollable container
function wrapTableContents(html) {
  return html.replace(
    /<table>(.*?)<\/table>/g,
    '<div class="c-Table dfb-Table dfb-Table--scroll"><div class="c-Table-tableContainer dfb-Table-tableContainer"><table>$1</table></div></div>'
  );
}

/**
 * Sanitize the content of an RTE field
 * @param {string} html The html content of an RTE field
 * @returns {string} Sanitized html content
 */
function sanitizeRteContent(html) {
  if (html) {
    html = wrapListItemContents(html)
    html = externalizeAnchors(html)
    html = sanitizeNewsText(html)
    html = wrapTableContents(html)
  }
  return html
}

function absolutizeImageSources(html) {
  if (html) {
    html = html.replace(/src=assets/g, "src=/assets")
    html = html.replace(/src="assets/g, 'src="/assets')
    html = html.replace(/src='assets/g, "src='/assets")
  }
  return html
}

function componentExistsInPage(component, page_body) {
  if (component && page_body && page_body.length > 0) {
    let i = 0
    for (i = 0; i < page_body.length; i++) {
      let element = page_body[i]
      if (element.component === component) {
        return true
      }
    }
  } else {
    return false
  }
}

function removeImageDescription(imageObj) {
  //delete imageObj.description
  return imageObj
}

let lastId = 0
function uniqueId(prefix = "id") {
  lastId++
  return `${prefix}${lastId}`
}

/**
 * Replaces all occurences of placeholders in the form $[key] with the value
 * of the key in the context object. Will insert empty strings if the key
 * is not found.
 * @param text The text that can contain placeholders.
 * @param context The context object
 */
function replacePlaceholder(text, context) {
  if (!text) {
    return text
  }
  return text.replace(/\$\[([^\s\]]*)\]/g, (all, key) => {
    if (context && context[key] != null) {
      return context[key]
    }
    return ""
  })
}

function conditionalLinkTarget(link, link_obj) {
  let target = {}
  if (link_obj && link_obj.target) {
    target = { target: link_obj.target }
  } else {
    target =
      link &&
        link.indexOf("/") !== 0 &&
        link.indexOf("http://www.dfb-akademie.de") !== 0 &&
        link.indexOf("https://www.dfb-akademie.de") !== 0 &&
        link.indexOf("http://mein.dfb-akademie.de") !== 0 &&
        link.indexOf("https://mein.dfb-akademie.de") !== 0
        ? { target: "_blank" }
        : {}
  }
  return target
}

export {
  formatDateRange,
  formatDate,
  getCategoryIconType,
  categoryIconMapping,
  concatStrings,
  defineBgColor,
  externalizeAnchors,
  getUsedRootCategoryIconTypes,
  wrapListItemContents,
  replaceTypo3Links,
  replaceUTF8Codes,
  retrieveItemImageFromHero,
  sanitizeNewsText,
  isTransparentHeaderSupported,
  truncateTextByWords,
  searchResultHeaderData,
  setSearchResultMarker,
  absolutizeImageSources,
  componentExistsInPage,
  removeImageDescription,
  uniqueId,
  replacePlaceholder,
  conditionalLinkTarget,
  sanitizeRteContent,
}
